import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./views/login.js";
import { RequireToken } from "./views/Auth.js";
import Dashboard from "./views/dashboard.js";
import Home from "./views/home.js";
import AddOrcamento from "./views/addorcamento.js";
import ProjetoCompleto from "./views/projetocompleto.js";
import AddProjetoCompleto from "./views/addprojetocompleto.js";
import EditProjetoCompleto from "./views/editprojetocompleto.js";
import ViewProjetoCompleto from "./views/viewprojetocompleto.js";
import Grafico from "./views/grafico.js";
import Fichaprojeto from "./views/fichaprojeto.js";
import Graficobarra from "./views/graficobarra.js";
import Gantt3 from "./views/gantt3.js";
import Gantt4 from "./views/gantt4.js";
import ViewBairro from "./views/viewprojetobairro.js";
import Fichasecretario from "./views/fichasecretario.js";
import EditSecretaria from "./views/editsecretaria.js";
import Perfil from "./views/perfil.js";
import ListaPCA from "./views/pca.js";
import AddPCA from "./views/addpca.js";
import EditPCA from "./views/editpca.js";
import ViewOrcamento from "./views/vieworcamento.js";
import AddProjetoBairro from "./views/addprojetobairro.js";
import ViewConvenioDade from "./views/viewconveniosdade.js";
import ViewConvenioEstadual from "./views/viewconvenioestadual.js";
import ViewConvenioFederal from "./views/viewconveniosfederal.js";
import ViewConvenioFinisa from "./views/viewconveniofinisa.js";
import ViewConvenioSempapel from "./views/viewconveniosempapel.js";
import AddConvenioDade from "./views/addconveniodade.js";
import AddConvenioEstadual from "./views/addconvenioestadual.js";
import AddConvenioFederal from "./views/addconveniofederal.js";
import AddConvenioFinisa from "./views/addconveniofinisa.js";
import AddConvenioSempapel from "./views/addconveniosempapel.js";
import SignUp from "./views/signup.js";
import DetalhesExecucao from "./views/detalhesexecucao.js";
import EstatisticasProjeto from "./views/estatisticaprojeto.js";
import MapaProject from "./views/MapaProject.js";
import RelatorioProjetos from "./views/RelatorioProjeto.js";
import ModalRelatorios from "./views/viewrelatorios.js";
function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          <Route path="" element={<Dashboard />}>
            <Route path="/" element={<Home />} />
            <Route path="login" element={<Login />} />
            <Route
              path="listapca"
              element={
                <RequireToken>
                  <ListaPCA />
                </RequireToken>
              }
            />
            <Route path="/mapa" element={<MapaProject />} />
            <Route
              path="/conveniosestadual"
              element={<RequireToken><ViewConvenioEstadual /></RequireToken>}
            />
            <Route
              path="/conveniossempapel"
              element={<RequireToken><ViewConvenioSempapel /></RequireToken>}
            />
            <Route
              path="/editconveniossempapel/:id"
              element={<RequireToken><AddConvenioSempapel /></RequireToken>}
            />
            <Route path="/register" element={<SignUp />} />
            <Route
              path="/addconveniossempapel"
              element={<RequireToken><AddConvenioSempapel /></RequireToken>}
            />
            <Route
              path="/addconveniosestadual"
              element={<RequireToken><AddConvenioEstadual /></RequireToken>}
            />
            <Route
              path="/addconveniosestadual/:id"
              element={<RequireToken><AddConvenioEstadual /></RequireToken>}
            />
            <Route path="/addconveniosfinisa" element={<RequireToken><AddConvenioFinisa /></RequireToken>} />
            <Route
              path="/editconveniofinisa/:id"
              element={<RequireToken><AddConvenioFinisa /></RequireToken>}
            />
            <Route
              path="/addconveniosfederal"
              element={<RequireToken><AddConvenioFederal /></RequireToken>}
            />
            <Route
              path="/editconveniofederal/:id"
              element={<RequireToken><AddConvenioFederal /></RequireToken>}
            />
            <Route path="/addconveniosdade" element={<RequireToken><AddConvenioDade /></RequireToken>} />
            <Route
              path="/editconveniosdade/:id"
              element={<RequireToken><AddConvenioDade /></RequireToken>}
            />
            <Route path="/relatorio/:id" element={<RelatorioProjetos />} />
            <Route path="/viewrelatorio/:projeto_id" element={<ModalRelatorios />} />

            <Route path="/conveniosfinisa" element={<RequireToken><ViewConvenioFinisa /></RequireToken>} />
            <Route path="/conveniosfederal" element={<RequireToken><ViewConvenioFederal /></RequireToken>} />
            <Route
              path="/editconveniosdade/:id"
              element={<RequireToken><AddConvenioDade /></RequireToken>}
            />
            <Route path="/conveniosdade" element={<RequireToken><ViewConvenioDade /></RequireToken>} />
            <Route path="/editpca/:id" element={<EditPCA />} />
            <Route
              path="addpca"
              element={
                <RequireToken>
                  <AddPCA />
                </RequireToken>
              }
            />
            <Route path="/orcamento" element={<ViewOrcamento />} />

            <Route
              path="/addorcamento"
              element={
                <RequireToken>
                  <AddOrcamento />
                </RequireToken>
              }
            />
            
            <Route path="detalhesexecucao/:id" element={<DetalhesExecucao />} />
            <Route
              path="estatisticasprojeto/:id"
              element={<EstatisticasProjeto />}
            />
            <Route
              path="/addprojetobairro"
              element={
                <RequireToken>
                  <AddProjetoBairro />
                </RequireToken>
              }
            />
            <Route path="/projetosbairros" element={<ViewBairro />} />
            
        
            <Route path="Gantt4/:id" element={<Gantt4 />} />
            <Route path="projetocompleto" element={<ProjetoCompleto />} />
            <Route
              path="createprojetocompleto"
              element={
                <RequireToken>
                  <AddProjetoCompleto />
                </RequireToken>
              }
            />
            <Route
              path="editprojetocompleto/:id"
              element={
                <RequireToken>
                  <EditProjetoCompleto />
                </RequireToken>
              }
            />
            <Route
              path="viewprojetocompleto/:id"
              element={<ViewProjetoCompleto />}
            />
            <Route path="Gantt3/:id" element={<Gantt3 />} />
            <Route path="gantt4" element={<Gantt4 />} />
            <Route path="grafico" element={<Grafico />} />
            
            <Route
              path="editsecretaria/:id"
              element={
                <RequireToken>
                  <EditSecretaria />
                </RequireToken>
              }
            />
            <Route path="" element={<RequireToken><ViewConvenioDade /></RequireToken>} />
            <Route path="fichasecretario" element={<Fichasecretario />} />
            <Route path="perfil" element={<Perfil />} />
            <Route path="fichaprojeto" element={<Fichaprojeto />} />
            <Route path="graficobarra" element={<Graficobarra />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
